<div class="auth-cta-container-main">
<div class="auth-cta-container">
  <div class="floating-elements">
    <div class="floating-element"></div>
    <div class="floating-element"></div>
    <div class="floating-element"></div>
  </div>

  <div class="auth-cta-image-content">
    <div class="auth-cta-brand-logo">
      <a routerLink="/">
        <img
          src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/insizon/insizon-logo-v2-png.png"
          alt="Insizon Logo"
          class="logo-image" 
          />
      </a>
    </div>
    <h3 class="auth-cta-welcome-text">Welcome Back!</h3>
    <div class="welcome-subtitle">
      We build innovative software solutions that solve real-world problems and
      drive business transformation.
    </div>
  </div>
</div>
</div>